import { render, staticRenderFns } from "./ser_form.vue?vue&type=template&id=172eff97&scoped=true&"
import script from "./ser_form.vue?vue&type=script&lang=js&"
export * from "./ser_form.vue?vue&type=script&lang=js&"
import style0 from "./ser_form.vue?vue&type=style&index=0&id=172eff97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172eff97",
  null
  
)

export default component.exports